import React from 'react';

import config from 'configs/app';
import * as mixpanel from 'lib/mixpanel/index';
import useSwitchOrAddChain from 'lib/web3/useSwitchOrAddChain';
import useProvider from 'lib/web3/useProvider';
import { WALLETS_INFO } from 'lib/web3/wallets';
import { Link } from 'toolkit/chakra/link';
import { toaster } from 'toolkit/chakra/toaster';
import { Text } from '@chakra-ui/react';
import IconSvg from 'ui/shared/IconSvg';

const feature = config.features.web3Wallet;

const NetworkAddToWallet = () => {
  const { provider, wallet } = useProvider();
  const switchOrAddChain = useSwitchOrAddChain();

  const handleClick = React.useCallback(async() => {
    if (!wallet || !provider) {
      return;
    }

    try {
      await switchOrAddChain();

      toaster.success({
        title: 'Success',
        description: 'Successfully switched to network',
      });

      mixpanel.logEvent(mixpanel.EventTypes.ADD_TO_WALLET, {
        Target: 'network',
        Wallet: wallet,
      });

    } catch (error) {
      toaster.error({
        title: 'Error',
        description: (error as Error)?.message || 'Something went wrong',
      });
    }
  }, [ switchOrAddChain, provider, wallet ]);

  if (!provider || !wallet || !config.chain.rpcUrls.length || !feature.isEnabled) {
    return null;
  }

  return (
    <Link
      href="#"
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="36px"
      width="180px"
      borderWidth="1px"
      borderColor={{ _light: '#e9ecef', _dark: 'whiteAlpha.200' }}
      borderRadius="sm"
      color="#081D35"
      transition="all 0.2s"
      px="0.25rem 0.5rem"
      bg="#e9ecef"
      _hover={{
        bg: 'gray.100',
        borderColor: 'gray.300',
        color: 'gray.700'
      }}
      _dark={{
        bg: 'gray.800',
        borderColor: 'gray.700',
        color: 'gray.400',
        _hover: {
          bg: 'gray.700',
          borderColor: 'gray.600',
          color: 'gray.300'
        }
      }}
      onClick={handleClick}
    >
      <IconSvg name={WALLETS_INFO[wallet].icon} boxSize={4} mr={2} />
      <Text fontSize="sm" fontWeight="medium">Add {config.chain.name}</Text>
    </Link>
  );
};

export default React.memo(NetworkAddToWallet);
